export interface SessionLike {
  sessionId: string;
}

/**
 * TRIL-381: decide whether THIS browser's session was revoked elsewhere.
 *
 * True only when the session list is **non-empty** (so it's populated and
 * consistent) and our `sessionId` is absent — i.e. someone signed this device
 * out. An empty list is treated as ambiguous (eventual consistency / no data
 * yet) → no logout, so we never kick a user on a transient/empty read.
 */
export function shouldLogoutForRevokedSession(
  sessions: SessionLike[] | null | undefined,
  currentSessionId: string | null | undefined,
): boolean {
  if (!currentSessionId) return false;
  if (!sessions || sessions.length === 0) return false;
  return !sessions.some((s) => s.sessionId === currentSessionId);
}
